/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/
import React, { useEffect, useCallback } from 'react';
import {
    Grid,
    CardContent,
    Typography,
    Button,
    List,
    ListItem
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getUserInfo } from '../../../../../../store/reducers/user/userAction';

const UserProfileInformations = ({ toggleEditPwd, toggleEdit, changeLoading }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);

    // Fetch user information from Redux store
    const fetchUserInfo = useCallback(async () => {
        try {
            await dispatch(getUserInfo()).unwrap();
        } catch (error) {
            console.error("Error fetching user info:", error);
        } finally {
            changeLoading(false);
        }
    }, [dispatch, changeLoading]);

    // Fetch user info when the component mounts
    useEffect(() => {
        fetchUserInfo();
    }, [fetchUserInfo]);

    return (
        <CardContent>
            <Grid container spacing={3}>

                {/* User Information */}
                <Grid item xs={12} sm={12} md={6}>
                    <List component="nav" disablePadding>
                        {[
                            { label: "User Name", value: user.username },
                            { label: "Email", value: user.email },

                        ].map(({ label, value }, index) => (
                            <ListItem key={index} disableGutters>
                                <Typography variant="h4">
                                    <b>{label}:</b> {value || 'N/A'}
                                </Typography>
                            </ListItem>
                        ))}
                    </List>
                </Grid>

                {/* Action Buttons */}
                <Grid item xs={12} sm={12} md={6}>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ marginTop: '20px', marginBottom: '20px' }}
                        onClick={() => { toggleEditPwd(false); toggleEdit(true); }}
                    >
                        Edit Contact Information
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        style={{ marginTop: '20px', marginBottom: '20px', marginLeft: '20px' }}
                        onClick={() => { toggleEditPwd(true); toggleEdit(false); }}
                    >
                        Edit Password
                    </Button>
                    <Button
                        style={{ marginTop: '20px', marginLeft: '20px', marginBottom: '20px' }}
                        onClick={() => navigate('/dashboard')}
                    >
                        Return
                    </Button>
                </Grid>
            </Grid>
        </CardContent>
    );
};

 
export default UserProfileInformations;
